// extracted by mini-css-extract-plugin
export default {"root":"color_picker___root___ce7680ae","item":"color_picker___item___e33df4d2","current":"color_picker___current___ab243777"};